// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__1-sbU","pokemonCard":"styles_pokemonCard__cTahL"};